module.exports = __webpack_public_path__ + "static/media/TextGenerator.9a97811a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TextGenerator.jpg
// module id = 776
// module chunks = 0